import { strToQuery } from '@plugin/searchRoute/utils'
import { assign, get, pull, sortBy } from 'lodash-es'
import { createContext, useCallback, useContext, useMemo, useState } from 'react'

export const FilterBaseContext = createContext()
export default function useFilterBaseContext() {
  return useContext(FilterBaseContext)
}

export function useFilterBaseState(defaultParams) {
  const defaultFilter = useMemo(() => strToQuery(defaultParams.filter), [defaultParams])
  const [filter, setFilter] = useState(strToQuery(defaultParams.filter))

  const toggleFilter = useCallback((alias, value) => {

    const data = assign({}, filter)
    const list = get(data, alias, [])
    const nvalue = /^\d+$/.test(value) ? parseFloat(value) : value
    if (list.includes(nvalue)) {
      pull(list, nvalue)
    } else {
      list.push(nvalue)
    }
    data[alias] = sortBy(list)
    setFilter(data)
  }, [filter, setFilter])

  const resetFilter = useCallback(alias => {
    const query = strToQuery(defaultParams.filter)
    if (alias) query[alias] = []
    setFilter(query)
  }, [setFilter, defaultParams])

  return {
    filter,
    defaultParams,
    defaultFilter,
    setFilter,
    toggleFilter,
    resetFilter
  }
}